module.exports = __webpack_public_path__ + "static/media/develop.daea6d89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/develop.jpg
// module id = 388
// module chunks = 0